export interface TabDefinition {
  id: string;
  title: string;
  component: string;
  description?: string;
  allowOnDisconnected?: boolean;
}

export const TAB_REGISTRY: TabDefinition[] = [
  {
    id: 'documentation',
    title: 'Documentation',
    component: 'documentation',
    description: 'View user documentation and help',
    allowOnDisconnected: true,
  },
  {
    id: 'currentProtocolPlot',
    title: 'Current Protocol',
    component: 'currentProtocolPlot',
    description: 'View full temperature history plot',
  },
  {
    id: 'temperaturePlot',
    title: 'Temperatures',
    component: 'temperaturePlot',
    description: 'Real-time temperature monitoring (60s window)',
  },
  {
    id: 'hardwareMonitorPlot',
    title: 'Hardware Monitor',
    component: 'hardwareMonitorPlot',
    description: 'Real-time debug data visualization (60s window)',
  },
  {
    id: 'serialIO',
    title: 'Serial I/O',
    component: 'serialIO',
    description: 'Raw serial communication monitor',
  },
  {
    id: 'pcrSettings',
    title: 'PCR Settings',
    component: 'pcrSettings',
    description: 'Configure PCR protocol parameters',
  },
  {
    id: 'logDisplay',
    title: 'Log',
    component: 'logDisplay',
    description: 'Application event log viewer',
  },
  {
    id: 'firmwareUpdate',
    title: 'Firmware Update',
    component: 'firmwareUpdate',
    description: 'Upload firmware to device',
  },
];
